
import { Component, Vue, Prop } from 'vue-property-decorator';
import EmployeeCard from './EmployeeCard.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { DataFiltersLoader } from '../../data-management/data-filters/loader/data-filters-loader';
import {
    EmployeesDataSource,
    EmployeeDataType
} from '../../data-management/data-sources/sources/employees-data-source';
import { Gui } from '../../gui/gui';
import { utilService } from '../../shared/services/UtilService';
import { default as axios, AxiosResponse } from 'axios';
import { downloadService } from '../../shared/services/DownloadService';
import { eventService } from '../../shared/services/EventService';
import store from '@/store/store';

@Component({
    components: {
        VuePerfectScrollbar,
        EmployeeCard
    }
})
export default class CardsContainer extends Vue {
    private scrollElement: HTMLElement;
    private scrollEventListener: (callbackFunction: () => void) => void = null;

    mounted() {
        this.scrollElement = this.$el.querySelector('.cards-container__scroll-area');
        this.scrollEventListener = (callbackFunction: () => void) =>
            this.scrollElement.addEventListener('scroll', () => callbackFunction());
    }

    private get persons() {
        return (store.state
            .dataFiltersManager as DataFiltersLoader).allFiltersMerger.filteredData.slice() as EmployeeDataType[];
    }

    private scrollToEmployee(scrollToY: number) {
        utilService.scrollToAnimated(this.scrollElement, scrollToY);
    }

    private getExport() {
        eventService.track('Export', 'Filter result');
        downloadService.downloadUserExportFile();
    }
}
